import { render, staticRenderFns } from "./AIKnowledgeCreateForm.vue?vue&type=template&id=5a20a454&scoped=true"
import script from "./AIKnowledgeCreateForm.vue?vue&type=script&lang=js"
export * from "./AIKnowledgeCreateForm.vue?vue&type=script&lang=js"
import style0 from "./AIKnowledgeCreateForm.vue?vue&type=style&index=0&id=5a20a454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20a454",
  null
  
)

export default component.exports